<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>订单详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="swb-back-row">
            <div class="tabs-layout">
                <el-tabs v-model="action" type="card" @tab-click="handleClick">
                    <el-tab-pane label="订单详情" name="first"></el-tab-pane>
                    <el-tab-pane label="派工信息" name="second"></el-tab-pane>
                    <el-tab-pane label="订单操作记录" name="three"></el-tab-pane>
                </el-tabs>
            </div>
            <div v-if="action == 'first'">
                <swb-servc-order-details :orderId="orderId" :selfPath="selfPath"></swb-servc-order-details>
            </div>
            <div v-else-if="action=='second'">
                <div v-if="addWork == 1">
                    <swb-servc-work-voucher-of-order :orderId="orderId" :shopId="shopId" :selfPath="selfPath" @action-chang="modifyAction($event)"></swb-servc-work-voucher-of-order>
                </div>
                <div v-else>
                    <swb-servc-work-voucher-add :orderId="orderId" @action-chang="modifyAction($event)"></swb-servc-work-voucher-add>
                </div>
            </div>
            <div v-else>
                <swb-servc-order-record-list :orderId="orderId"></swb-servc-order-record-list>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import servcOrderApi from '../../api/servcOrder'

    import SwbServcOrderDetails from './ServcOrderDetails';
    Vue.regist(SwbServcOrderDetails);

    import SwbServcWorkVoucherAdd from '../workVoucher/ServcWorkVoucherAdd';
    Vue.regist(SwbServcWorkVoucherAdd);

    import SwbServcWorkVoucherOfOrder from '../workVoucher/ServcWorkVoucherOfOrder';
    Vue.regist(SwbServcWorkVoucherOfOrder);

    import ServcOrderRecordList from '../servcOrder/ServcOrderRecordList'
    Vue.regist(ServcOrderRecordList);
    export default {
        name: 'swb-servc-order-operate',
        path: '/servc/order/detail',
        pathOld: '/serv/order/details',
        avlActions: 'apply_after_sale|create_order_by_proxy|add_work_voucher|view_charge_item|to_work_voucher|update_discount',
        avlScopes: 'servicer', // (申请售后、代理下单、新增派工单、查看收费项)
        notAsResc: false,
        authen: false,
        desc: '服务订单详情',
        data: function () {
            return {
                action: 'first',
                orderId: null,
                shopId: null,
                addWork: 1,
                selfPath: Vue.$getClassInfo(this).path
            }
        },
        created: function () {
            this.orderId = this.$route.query.id;
            this.getServOrderInfo();
        },
        methods: {
            handleClick: function () {
                this.addWork = 1;
            },
            modifyAction: function (eventData) {
                if(eventData != null) {
                    this.addWork = eventData;
                }
            },
            getServOrderInfo: function () {
                let self = this;
                let id = self.orderId;
                servcOrderApi.getServcOrderInfo(id, function (result) {
                    if(result.type == "info") {
                        self.shopId = result.data.servicerShopId;
                    } else {
                        loading.close();
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servcOrder/ServcOrderOperate.vue